const mainHeaderMobilePanels = document.querySelectorAll<HTMLElement>('.main-header-mobile-panel');

mainHeaderMobilePanels.forEach(panel => {
  const closeButtons = panel.querySelectorAll<HTMLElement>('.main-header-mobile-panel__close');
  const backButton = panel.querySelector<HTMLElement>('.main-header-mobile-panel__back');

  closeButtons.forEach(closeButton => {
    closeButton?.addEventListener('click', (e) => {
      e.preventDefault();
      mainHeaderMobilePanels.forEach(panel => {
        panel.classList.remove('--open');
        document.body.classList.remove('--disable-scroll');
      })
    })
  })

  backButton?.addEventListener('click', (e) => {
    e.preventDefault();
    const closestPanel = backButton.closest('.main-header-mobile-panel')
    closestPanel?.classList.remove('--open');
    const parentPanel = closestPanel.parentElement.closest('.main-header-mobile-panel');
    parentPanel?.classList.remove('--child-open');
  })
})
